import { LanguageType, MediaType, PlatformType, ServiceType } from '../enum/app.enum';

export const mainSlideList = [
  {
    language: LanguageType.Ko,
    list: [
      {
        serviceTitle: 'Chat',
        titleExplain: '안전한 AI 학습 도우미',
        title: '투닝 챗',
        site: 'https://tooning.io/chat-information',
        css: ServiceType.Chat,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-chat.webp',
        alt: 'chat'
      },
      {
        serviceTitle: 'Character',
        titleExplain: '나만의 AI 지식 튜터',
        title: '투닝 캐릭터',
        site: 'https://tooning.io/gpt-information',
        css: ServiceType.Character,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-character.webp',
        alt: 'character'
      },
      {
        serviceTitle: 'Magic',
        titleExplain: '예술과 AI의 만남',
        title: '투닝 매직',
        site: 'https://tooning.io/magic-information',
        css: ServiceType.Magic,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-magic.webp',
        alt: 'magic'
      },
      {
        serviceTitle: 'Editor',
        titleExplain: '누구나 만드는 스토리 콘텐츠',
        title: '투닝 에디터',
        site: 'https://tooning.io/editor-information',
        css: ServiceType.Editor,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-editor.webp',
        alt: 'editor'
      },
      {
        serviceTitle: 'Board',
        titleExplain: '모든 콘텐츠를 한 곳에',
        title: '투닝 보드',
        site: 'https://tooning.io/board-information',
        css: ServiceType.Board,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-board.webp',
        alt: 'board'
      },
      {
        serviceTitle: 'Stories',
        titleExplain: '이야기를 쉽고 빠르게',
        title: '스토리즈',
        site: 'https://plus.tooning.io/stories',
        css: ServiceType.Stories,
        platform: PlatformType.Plus,
        type: MediaType.Video,
        src: 'https://imweb.tooning.io/plus/StoriesMockupKO.webm',
        poster: '/images/main-slide/StoriesMockupKO.webp'
      },
      {
        serviceTitle: '3D Studio',
        titleExplain: '캐릭터 제작의 시작과 끝',
        title: '3D 스튜디오',
        site: 'https://plus.tooning.io/3d-studio',
        css: ServiceType.Studio,
        platform: PlatformType.Plus,
        type: MediaType.Video,
        src: 'https://imweb.tooning.io/plus/3DstudioMockupKO.webm',
        poster: '/images/main-slide/3DstudioMockupKO.webp'
      },
      {
        serviceTitle: 'Editor',
        titleExplain: '창작을 쉽고 빠르게 만드는',
        title: '에디터',
        site: 'https://plus.tooning.io/editor',
        css: ServiceType.PlusEditor,
        platform: PlatformType.Plus,
        type: MediaType.Video,
        src: 'https://imweb.tooning.io/plus/EditorMockupKO.webm',
        poster: '/images/main-slide/EditorMockupKO.webp'
      }
      // {
      //   serviceTitle: 'Deev',
      //   titleExplain: 'AI 채팅에 딥-하게 빠지다',
      //   title: '디브',
      //   site: 'https://deev.world/home',
      //   css: ServiceType.Deev,
      //   platform: PlatformType.Plus,
      //   type: MediaType.Image,
      //   src: '/images/main-slide/main-slide-img-deev.webp',
      //   alt: 'deev'
      // }
    ]
  },
  {
    language: LanguageType.En,
    list: [
      {
        serviceTitle: 'Chat',
        titleExplain: 'The safest AI learning assistant',
        title: 'Tooning Chat',
        site: 'https://tooning.io/chat-information',
        css: ServiceType.Chat,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-chat.webp',
        alt: 'chat'
      },
      {
        serviceTitle: 'Character',
        titleExplain: 'Your own AI tutor',
        title: 'Tooning Character',
        site: 'https://tooning.io/gpt-information',
        css: ServiceType.Character,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-character.webp',
        alt: 'character'
      },
      {
        serviceTitle: 'Magic',
        titleExplain: 'Where art meets AI',
        title: 'Tooning Magic',
        site: 'https://tooning.io/magic-information',
        css: ServiceType.Magic,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-magic.webp',
        alt: 'magic'
      },
      {
        serviceTitle: 'Editor',
        titleExplain: 'Storytelling content made easy',
        title: 'Tooning Editor',
        site: 'https://tooning.io/editor-information',
        css: ServiceType.Editor,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-editor.webp',
        alt: 'editor'
      },
      {
        serviceTitle: 'Board',
        titleExplain: 'All your content in one place',
        title: 'Tooning Board',
        site: 'https://tooning.io/board-information',
        css: ServiceType.Board,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-board.webp',
        alt: 'board'
      },
      {
        serviceTitle: 'Stories',
        titleExplain: 'Easy story customizer',
        title: 'Stories',
        site: 'https://plus.tooning.io/stories',
        css: ServiceType.Stories,
        platform: PlatformType.Plus,
        type: MediaType.Video,
        src: 'https://imweb.tooning.io/plus/StoriesMockupEN.webm',
        poster: '/images/main-slide/StoriesMockupEN.webp'
      },
      {
        serviceTitle: '3D Studio',
        titleExplain: 'Character creation from start to finish',
        title: '3D Studio',
        site: 'https://plus.tooning.io/3d-studio',
        css: ServiceType.Studio,
        platform: PlatformType.Plus,
        type: MediaType.Video,
        src: 'https://imweb.tooning.io/plus/3DstudioMockupEN.webm',
        poster: '/images/main-slide/3DstudioMockupEN.webp'
      },
      {
        serviceTitle: 'Editor',
        titleExplain: 'Create fast, edit smart',
        title: 'Editor',
        site: 'https://plus.tooning.io/editor',
        css: ServiceType.PlusEditor,
        platform: PlatformType.Plus,
        type: MediaType.Video,
        src: 'https://imweb.tooning.io/plus/EditorMockupEN.webm',
        poster: '/images/main-slide/EditorMockupEN.webp'
      }
      // {
      //   serviceTitle: 'Deev',
      //   titleExplain: 'Dive deep into AI chat',
      //   title: 'Deev',
      //   site: 'https://deev.world/home',
      //   css: ServiceType.Deev,
      //   platform: PlatformType.Plus,
      //   type: MediaType.Image,
      //   src: '/images/main-slide/main-slide-img-deev.webp',
      //   alt: 'deev'
      // }
    ]
  },
  {
    language: LanguageType.Fr,
    list: [
      {
        serviceTitle: 'Chat',
        titleExplain: 'L’assistant d’apprentissage IA le plus sûr',
        title: 'Tooning Chat',
        site: 'https://tooning.io/chat-information',
        css: ServiceType.Chat,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-chat.webp',
        alt: 'chat'
      },
      {
        serviceTitle: 'Character',
        titleExplain: 'Votre tuteur IA personnel',
        title: 'Tooning Character',
        site: 'https://tooning.io/gpt-information',
        css: ServiceType.Character,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-character.webp',
        alt: 'character'
      },
      {
        serviceTitle: 'Magic',
        titleExplain: 'Là où l’art rencontre l’IA',
        title: 'Tooning Magic',
        site: 'https://tooning.io/magic-information',
        css: ServiceType.Magic,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-magic.webp',
        alt: 'magic'
      },
      {
        serviceTitle: 'Editor',
        titleExplain: 'Le storytelling simplifié',
        title: 'Tooning Editor',
        site: 'https://tooning.io/editor-information',
        css: ServiceType.Editor,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-editor.webp',
        alt: 'editor'
      },
      {
        serviceTitle: 'Board',
        titleExplain: 'Tout votre contenu au même endroit',
        title: 'Tooning Board',
        site: 'https://tooning.io/board-information',
        css: ServiceType.Board,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-board.webp',
        alt: 'board'
      },
      {
        serviceTitle: 'Stories',
        titleExplain: 'Personnalisation d’histoire simplifiée',
        title: 'Stories',
        site: 'https://plus.tooning.io/stories',
        css: ServiceType.Stories,
        platform: PlatformType.Plus,
        type: MediaType.Video,
        src: 'https://imweb.tooning.io/plus/StoriesMockupEN.webm',
        poster: '/images/main-slide/StoriesMockupEN.webp'
      },
      {
        serviceTitle: '3D Studio',
        titleExplain: 'Création de personnages de A à Z',
        title: '3D Studio',
        site: 'https://plus.tooning.io/3d-studio',
        css: ServiceType.Studio,
        platform: PlatformType.Plus,
        type: MediaType.Video,
        src: 'https://imweb.tooning.io/plus/3DstudioMockupEN.webm',
        poster: '/images/main-slide/3DstudioMockupEN.webp'
      },
      {
        serviceTitle: 'Editor',
        titleExplain: 'Création simple et rapide',
        title: 'Editor',
        site: 'https://plus.tooning.io/editor',
        css: ServiceType.PlusEditor,
        platform: PlatformType.Plus,
        type: MediaType.Video,
        src: 'https://imweb.tooning.io/plus/EditorMockupEN.webm',
        poster: '/images/main-slide/EditorMockupEN.webp'
      }
      // {
      //   serviceTitle: 'Deev',
      //   titleExplain: 'Plongez dans le chat IA',
      //   title: 'Deev',
      //   site: 'https://deev.world/home',
      //   css: ServiceType.Deev,
      //   platform: PlatformType.Plus,
      //   type: MediaType.Image,
      //   src: '/images/main-slide/main-slide-img-deev.webp',
      //   alt: 'deev'
      // }
    ]
  },
  {
    language: LanguageType.Jp,
    list: [
      {
        serviceTitle: 'Chat',
        titleExplain: '安全なAI学習アシスタント',
        title: 'Tooning Chat',
        site: 'https://tooning.io/chat-information',
        css: ServiceType.Chat,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-chat.webp',
        alt: 'chat'
      },
      {
        serviceTitle: 'Character',
        titleExplain: '自分だけのAI知識チューター',
        title: 'Tooning Character',
        site: 'https://tooning.io/gpt-information',
        css: ServiceType.Character,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-character.webp',
        alt: 'character'
      },
      {
        serviceTitle: 'Magic',
        titleExplain: 'アートとAIの融合',
        title: 'Tooning Magic',
        site: 'https://tooning.io/magic-information',
        css: ServiceType.Magic,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-magic.webp',
        alt: 'magic'
      },
      {
        serviceTitle: 'Editor',
        titleExplain: '誰もがつくるストーリーコンテンツ',
        title: 'Tooning Editor',
        site: 'https://tooning.io/editor-information',
        css: ServiceType.Editor,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-editor.webp',
        alt: 'editor'
      },
      {
        serviceTitle: 'Board',
        titleExplain: 'すべてのコンテンツを一か所に',
        title: 'Tooning Board',
        site: 'https://tooning.io/board-information',
        css: ServiceType.Board,
        platform: PlatformType.Edu,
        type: MediaType.Image,
        src: '/images/main-slide/main-slide-img-board.webp',
        alt: 'board'
      },
      {
        serviceTitle: 'Stories',
        titleExplain: '物語を手軽に、そして素早く',
        title: 'Stories',
        site: 'https://plus.tooning.io/stories',
        css: ServiceType.Stories,
        platform: PlatformType.Plus,
        type: MediaType.Video,
        src: 'https://imweb.tooning.io/plus/StoriesMockupEN.webm',
        poster: '/images/main-slide/StoriesMockupEN.webp'
      },
      {
        serviceTitle: '3D Studio',
        titleExplain: 'キャラクター制作の始まりから終わりまで',
        title: '3D Studio',
        site: 'https://plus.tooning.io/3d-studio',
        css: ServiceType.Studio,
        platform: PlatformType.Plus,
        type: MediaType.Video,
        src: 'https://imweb.tooning.io/plus/3DstudioMockupEN.webm',
        poster: '/images/main-slide/3DstudioMockupEN.webp'
      },
      {
        serviceTitle: 'Editor',
        titleExplain: '創作をもっと簡単に、もっと早くする',
        title: 'Editor',
        site: 'https://plus.tooning.io/editor',
        css: ServiceType.PlusEditor,
        platform: PlatformType.Plus,
        type: MediaType.Video,
        src: 'https://imweb.tooning.io/plus/EditorMockupEN.webm',
        poster: '/images/main-slide/EditorMockupEN.webp'
      }
      // {
      //   serviceTitle: 'Deev',
      //   titleExplain: 'AIチャットの世界に深く潜る',
      //   title: 'Deev',
      //   site: 'https://deev.world/home',
      //   css: ServiceType.Deev,
      //   platform: PlatformType.Plus,
      //   type: MediaType.Image,
      //   src: '/images/main-slide/main-slide-img-deev.webp',
      //   alt: 'deev'
      // }
    ]
  }
];
